import { createModuleStore } from '../utils'

export const useLocationTagsStore = createModuleStore(
  'location-tags',
  {
    type: 'Location Tag',
    pageHeading: 'Location Tags',
    noHistory: true,
    sortingOn: 'toolbar',
    statusesFilterName: 'statuses',
    uploadOptionsCsv: '',
    downloadOptionsCsv: '',
    uri: '/location-tags',
    serviceUri: '/location-tags',
    listingModuleName: 'Config',
    listingActivityName: 'View Location Tag',
    formModuleName: 'Config',
    formActivityName: 'Edit Location Tag',
    allFields: [
      {
        key: 'name',
        title: 'NAME',
        visible: true,
        disabled: true,
        sortable: true,
      },
      {
        key: 'description',
        title: 'DESCRIPTION',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'category',
        title: 'CATEGORY',
        type: 'category',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'firstTimestamp',
        title: 'FIRST SCANNED TIME',
        type: 'micros',
        sortable: false,
        visible: false,
        disabled: false,
      },
      {
        key: 'lastTimestamp',
        title: 'LAST SCANNED TIME',
        type: 'micros',
        sortable: false,
        visible: false,
        disabled: false,
      },
      {
        key: 'allocatedReadZone',
        title: 'ALLOCATED LOCATION',
        type: 'readZone',
        sortable: true,
        visible: true,
        disabled: false,
      },
      {
        key: 'currentReadZone',
        title: 'CURRENT LOCATION',
        type: 'readZone',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'parent',
        title: 'PARENT',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'tags',
        title: 'RFID TAG(s)',
        sortable: true,
        type: 'tags',
        visible: true,
        disabled: false,
      },
      {
        key: 'serialNumber',
        title: 'SERIAL NUMBER',
        visible: true,
        disabled: false,
        sortable: true,
      },
      {
        key: 'status',
        title: 'STATUS',
        visible: true,
        disabled: false,
        sortable: true,
      },
      {
        key: 'tagsCsv',
        title: 'TAG(s) CSV',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'externalId',
        title: 'UUID',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'createdBy',
        title: 'CREATED BY',
        visible: false,
        disabled: false,
        sortable: true,
      },
      {
        key: 'createdTimestamp',
        title: 'CREATED TIME',
        type: 'datetime',
        visible: false,
        disabled: false,
        sortable: true,
      },
      {
        key: 'lastModifiedBy',
        title: 'LAST MODIFIED BY',
        visible: false,
        disabled: false,
        sortable: true,
      },
      {
        key: 'lastModifiedTimestamp',
        title: 'LAST MODIFIED TIME',
        type: 'datetime',
        visible: false,
        disabled: false,
        sortable: true,
      },
      {
        key: 'actions',
        title: 'ACTIONS',
        visible: true,
        disabled: true,
        sortable: false,
      },
    ],
  },
  {
    tagAllocationLabel: 'Pick Existing Readzone',
  },
  {
    transform(item) {
      const obj = {
        externalId: item.externalId,
        tags: item.tags,
        serialNumber: item.serialNumber,
        name: item.name,
        description: item.description,
        pickExistingRdzn: true,
        allocatedReadZone: item.allocatedReadZone,
      }
      return obj
    },

    tagAllocationUpdated(allocation) {
      const store = useLocationTagsStore()
      store.form.tagAllocationLabel = allocation ? 'Pick Existing Readzone' : 'Create New Readzone'
      store.form.fields.forEach((field) => {
        if (field.name === 'site' || field.name === 'name') {
          field.visible = !allocation
        }
        if (field.name === 'allocatedReadZone') {
          field.visible = allocation
        }
      })
    },
    resetPageFilters() {
      const store = useLocationTagsStore()
      store.resetBaseFilters()
    },
  },
  {
    actionBindings: {
      pickExistingRdzn: 'tagAllocationUpdated',
    },
    fields: [
      {
        id: 'location_tags_serial_number',
        name: 'serialNumber',
        label: 'Serial Number',
        size: 12,
        component: 'NInput',
        componentProps: { placeholder: 'Enter serial number of the location tag' },
        rules: [
          {
            required: false,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'location_tags',
        name: 'tags',
        label: 'RFID Tag(s)',
        size: 12,
        component: 'ArsTagSelect',
        componentProps: {
          multiple: true,
          filterable: true,
          placeholder: 'Select tags',
        },
        rules: [
          {
            required: false,
            type: 'array',
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'location_tags_allocation',
        name: 'pickExistingRdzn',
        templateLabel: 'tagAllocationLabel',
        label: 'Tag Allocation',
        size: 6,
        component: 'NCheckbox',
        defaultValue: true,
        componentProps: {},
        rules: [
          {
            type: 'boolean',
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'location_tags_name',
        name: 'name',
        label: 'Name',
        size: 9,
        visible: true,
        componentProps: { placeholder: 'Enter name' },
        component: 'NInput',
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'location_site',
        name: 'site',
        label: 'Site',
        size: 9,
        component: 'ArsSmartSelect',
        visible: false,
        submitValueKey: 'externalId',
        componentProps: {
          multiple: false,
          placeholder: 'Pick Site',
          serviceUri: '/sites',
          dxTableName: 'Sites',
          optionsLabel: 'name',
          clearable: false,
        },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'location_allocated_readZone',
        name: 'allocatedReadZone',
        label: 'Allocated ReadZone',
        size: 18,
        component: 'ArsSmartSelect',
        visible: true,
        componentProps: {
          multiple: false,
          filterable: true,
          placeholder: 'Select Readzone',
          serviceUri: '/readzones',
          optionsLabel: 'name',
        },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'location_tags_description',
        name: 'description',
        label: 'Description',
        size: 24,
        componentProps: { placeholder: 'Enter description' },
        component: 'NInput',
        rules: [
          {
            required: false,
            trigger: ['blur', 'input'],
          },
        ],
      },
    ],
  }
)
